import React, { useState } from 'react';
import { UpdateBusinessUnitData } from '../GroupDetails.types';
import { useUpdateBusinessUnits } from './useUpdateBusinessUnits';
import { useParams } from 'react-router-dom';
import { UseMutateFunction } from 'react-query';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';

type UseDeleteBUModalFacade = () => {
  buToDelete: false | UpdateBusinessUnitData;
  setBuToDelete: React.Dispatch<React.SetStateAction<false | UpdateBusinessUnitData>>;
  closeDeleteBUModal: () => void;
  removeBusinessUnit: UseMutateFunction<AxiosResponse<void>, ErrorResponse, UpdateBusinessUnitData>;
  isRemovingBusinessUnit: boolean;
};

export const useDeleteBUModalFacade: UseDeleteBUModalFacade = () => {
  const { id } = useParams<{ id: string }>();
  const [buToDelete, setBuToDelete] = useState<false | UpdateBusinessUnitData>(false);

  const closeDeleteBUModal = () => setBuToDelete(false);

  const { updateBusinessUnit: removeBusinessUnit, isUpdating: isRemovingBusinessUnit } =
    useUpdateBusinessUnits(false, id, closeDeleteBUModal);

  return {
    buToDelete,
    setBuToDelete,
    closeDeleteBUModal,
    removeBusinessUnit,
    isRemovingBusinessUnit,
  };
};
